module.exports = __webpack_public_path__ + "static/img/4.4a700fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/4.png
// module id = HSTN
// module chunks = 0